/*
 * pf-mega-menu.js — abertura por hover (com intenção) do mega menu desktop.
 *
 * Dois tipos de item de topo:
 *   A) com filhos no menu do Admin → <details>/<summary>, funciona sozinho
 *      (clique + teclado + sem JS); aqui só se acrescenta hover, fecho e Escape;
 *   B) sem filhos, a apontar para colecção (DETAIL SERIES, MAIS VENDIDOS,
 *      SALDOS) → <a> + painel irmão, aberto por hover/focus com a classe
 *      `is-open`. Fica <a> de propósito: nestes o clique tem de navegar.
 *
 * Só liga em ponteiro fino e >=1280px, que é onde o nav inline existe
 * (header.liquid suprime-o abaixo disso e passa a mão ao drawer).
 */
(function () {
  const OPEN_DELAY = 90;
  const CLOSE_DELAY = 180;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const isDesktop = window.matchMedia('(min-width: 1280px)');

  function init() {
    const nav = document.querySelector('.header__inline-menu.pf-mega');
    if (!nav || nav.dataset.pfMegaReady === 'true') return;
    nav.dataset.pfMegaReady = 'true';

    const allItems = Array.from(nav.querySelectorAll('.pf-mega__item'));
    const detailsOf = (li) => li.querySelector('details.pf-mega__details');
    const autoPanelOf = (li) => li.querySelector(':scope > .pf-mega__panel');

    let openTimer = null;
    let closeTimer = null;

    const clearTimers = () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
    };

    const setDetails = (details, open) => {
      if (!details || details.open === open) return;
      details.open = open;
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', String(open));
    };

    const closeAll = (exceptLi) => {
      allItems.forEach((li) => {
        if (li === exceptLi) return;
        setDetails(detailsOf(li), false);
        li.classList.remove('is-open');
      });
    };

    const openItem = (li) => {
      closeAll(li);
      const details = detailsOf(li);
      if (details) {
        setDetails(details, true);
      } else if (autoPanelOf(li)) {
        li.classList.add('is-open');
      }
    };

    const anythingOpen = () =>
      nav.querySelector('details.pf-mega__details[open]') || nav.querySelector('.pf-mega__item.is-open');

    allItems.forEach((li) => {
      const details = detailsOf(li);
      const hasPanel = Boolean(details || autoPanelOf(li));

      li.addEventListener('mouseenter', () => {
        if (!canHover.matches || !isDesktop.matches) return;
        clearTimers();
        // Itens sem painel também agendam: passar por cima de um deles tem de
        // fechar o painel do vizinho, senão fica pendurado.
        openTimer = setTimeout(() => (hasPanel ? openItem(li) : closeAll(null)), OPEN_DELAY);
      });

      li.addEventListener('mouseleave', () => {
        if (!canHover.matches || !isDesktop.matches) return;
        clearTimeout(openTimer);
      });

      // Teclado: focar o item abre o painel (os cards vêm logo a seguir na
      // ordem de tab). Nos itens do tipo B o <a> continua a navegar no Enter.
      if (hasPanel && !details) {
        li.addEventListener('focusin', () => {
          if (!isDesktop.matches) return;
          openItem(li);
        });
      }

      // Fonte única de verdade para o aria: o evento `toggle` do próprio
      // <details>. Sincronizar no clique deixava o aria dessincronizado quando
      // o painel era aberto por hover (juiz 2026-08-14 apanhou esse caso).
      if (details) {
        details.addEventListener('toggle', () => {
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) closeAll(li);
        });
      }
    });

    nav.addEventListener('mouseenter', clearTimers);

    nav.addEventListener('mouseleave', () => {
      if (!canHover.matches || !isDesktop.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => closeAll(null), CLOSE_DELAY);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = anythingOpen();
      if (!open) return;
      const li = open.closest('.pf-mega__item');
      closeAll(null);
      const focusTarget = li && li.querySelector('summary, a.header__menu-item');
      if (focusTarget) focusTarget.focus();
    });

    document.addEventListener('click', (event) => {
      if (!anythingOpen() || nav.contains(event.target)) return;
      closeAll(null);
    });

    // Sem fecho ao scroll: fechava o painel debaixo do rato de quem estava a
    // percorrer os cards com a roda do rato. O mouseleave e o clique-fora
    // chegam.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
